var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternationalYouthLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.814 24.258c5.907 0 10.696-4.79 10.696-10.696 0-5.908-4.789-10.697-10.696-10.697S3.118 7.655 3.118 13.562c0 5.907 4.789 10.696 10.696 10.696z",
    fill: "#D6C9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.858 15.063v.5h3.276l2.689 2.689-.033 3.804-.002.213.152.149 1.856 1.812a12.76 12.76 0 0 1-.08-.019c-.996-.242-2.32-.663-3.638-1.383-2.622-1.43-5.21-4.019-5.21-8.76 0-3.79 1.89-6.398 3.808-8.076A14.66 14.66 0 0 1 9.32 4.159a12.76 12.76 0 0 1 1.104-.532l.06-.023.014-.006h.002l.325-.122v-.06h.989v.213h1.989v4.164l-1.39.695-.74-.74-.147-.146H8.83v2.205L4.1 12.645l-.242.146V15.063z",
    fill: "#EBDEF5",
    stroke: "url(#9wwbkqe78a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.276 8.335-1.32.66V7.967l.729-.729H20V6.074l1.204-.41c.11.104.257.249.43.432.39.41.911 1.011 1.432 1.765 1.046 1.515 2.065 3.615 2.065 6.03 0 3.9-1.944 6.584-3.917 8.31a15.068 15.068 0 0 1-2.66 1.853l2.415-4.83.112-.223-.112-.223-1.022-2.044-.138-.277h-2.146l-1.751-1.75v-1.63l1.75-1.751h1.72l1.938.969.447.223.224-.447 1.022-2.044.257-.515-.546-.183-3.066-1.022-.197-.065-.185.093z",
    fill: "#EBDEF5",
    stroke: "url(#9ati4l7lyb)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.118 24.865c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "url(#9a67q32p4c)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9wwbkqe78a",
    x1: 0.993,
    y1: 15.145,
    x2: 14.347,
    y2: 15.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824BAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9ati4l7lyb",
    x1: 14.234,
    y1: 16.188,
    x2: 25.67,
    y2: 16.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824BAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9a67q32p4c",
    x1: 0.582,
    y1: 15.044,
    x2: 25.2,
    y2: 14.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824BAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalYouthLight);
export default __webpack_public_path__ + "static/media/International_Youth_Light.e04aa898a9dc72bf7a92a7e66673327c.svg";
export { ForwardRef as ReactComponent };